import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "top-scoring-list-selector"
}
const _hoisted_2 = ["onClick"]

import { PropType } from 'vue'

import NotificationBanner from '@/components/common/NotificationBanner.vue'
import { TopScoringListInfo } from '@/store/modules/top-scoring-lists.types'


export default /*@__PURE__*/_defineComponent({
  __name: 'TopScoringListSelector',
  props: {
  availableLists: {
    type: Array as PropType<TopScoringListInfo[]>,
    default: () => [],
  },
},
  emits: ['selectList'],
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (__props.availableLists?.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.availableLists, (list) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `top-scoring-list-${list.id}`,
            class: "top-scoring-list-selector-item",
            onClick: ($event: any) => (_ctx.$emit('selectList', list.id))
          }, _toDisplayString(list.name), 9, _hoisted_2))
        }), 128))
      ]))
    : (_openBlock(), _createBlock(NotificationBanner, {
        key: 1,
        message: _ctx.$t('top-scoring-lists.no-available-lists')
      }, null, 8, ["message"]))
}
}

})